<div class="main-window">
   <app-upper-bar class="upper-bar"></app-upper-bar>
   <div class="main-app">
      <icms-split [areas]="icmsSplitAreasHorizontal" direction='horizontal' [showLock]="false" [preset]="splitScreenPreset">
         <ng-template matTabContent>
            <icms-split [areas]="icmsSplitAreasVertical" direction='vertical'  [showLock]="false" [preset]="splitScreenPreset">
               <ng-template matTabContent>
                  <icms-split [areas]="icmsSplitAreasHorizontalSmall" direction='horizontal'  [showLock]="false">
                     <ng-template matTabContent>
                        <app-search-list #presets title="Presets">
                           <app-presets [query$]=presets.query$></app-presets>
                        </app-search-list>
                     </ng-template>
                     <ng-template matTabContent>
                        <app-search-list #cameras title="Cameras">
                           <app-camera-list [query$]=cameras.query$></app-camera-list>
                        </app-search-list>
                     </ng-template>
                  </icms-split>   
               </ng-template>
               <ng-template matTabContent>
                  <div class="map-window">
                     <coord-panel class="coord-panel"></coord-panel>
                     <div class="main-map" id="myMap">
                        <newmi-map class="newmi-map" [mui-config]="newmiLoadingConfig" (mui-on-loaded)="onMapLoaded($event)"></newmi-map>
                        <div class="status-bar"><status-bar></status-bar></div>
                        <div class="tool-bar"><app-tool-bar></app-tool-bar></div>
                     </div>
                     <div class="side-nav"><side-navigation></side-navigation></div>
                     <objects-menu></objects-menu>
                  </div> 
               </ng-template>
            </icms-split>
         </ng-template>
         <ng-template>
            <video-split></video-split>
         </ng-template>
         <ng-template>
            <alert-list></alert-list>
         </ng-template>
      </icms-split>
   </div>
</div>
   
   
   
   
   